<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span v-if="showHeader">Citizenship</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here" class="my-0 py-0"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.duties="{item}">
          <slot name="duties" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.benefits="{item}">
          <slot name="benefits" v-bind:item="item"></slot>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    headers: {
      default: () => [],
      type: Array
    },
    items: {
      default: () => [],
      type: Array
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    search: "",
    footerProps: {
      rowsPerPageItems: [10, 20, 50]
    }
  })
};
</script>